import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';
import App from '@app/app';
import type { ButtonSize, ButtonVariant } from './lt-button.config';
export { ButtonSize, ButtonVariant, LT_BUTTON_SIZES, LT_BUTTON_VARIANTS } from './lt-button.config';
import loaderIcon from '/images/fa-regular-fa-loader.svg';

@Component({
  selector: 'lt-button',
  templateUrl: './lt-button.component.html',
  styleUrl: './lt-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LtButtonComponent {
  testId = input.required<string>();
  variant = input<ButtonVariant>('primary');
  size = input<ButtonSize>('medium');
  disabled = input<boolean>(false);
  loading = input<boolean>(false);
  type = input<'button' | 'submit'>('button');
  tabIndex = input<number>(0);

  readonly loaderIcon = loaderIcon;
}

App.directive('ltButton', downgradeComponent({ component: LtButtonComponent }));
